// extracted by mini-css-extract-plugin
module.exports = {"main":"OnlineLoadBooking_main__gooFw","herosectionImageBox":"OnlineLoadBooking_herosectionImageBox__vrwUt"};